import { EventEmitter, Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ReportingComponentProps<T> {
    component: Type<T>;
    inputs?: { [prop in keyof T]?: T[prop] extends EventEmitter<unknown> ? never : T[prop] };
    // Da decidere se supportare.
    // Da controllare se servirebbe un unsubscribe manuale, o sarebbe automatico.
    // outputs?: { [prop in keyof T]?: T[prop] extends EventEmitter<unknown> ? T[prop] : never };
}

export type SideTabKey =
    | 'patientHistory'
    | 'reportHistory';

@Injectable({
    providedIn: 'root',
})
export class SeSideService {

    public previousFormType : string | null = null;
    get reportingComponent$() {
        return this.reportingComponentSubject.asObservable();
    }

    private reportingComponentSubject = new BehaviorSubject<ReportingComponentProps<any> | null>(null);

    setReportingComponent<T>(props: ReportingComponentProps<T>) {
        this.reportingComponentSubject.next(props);
    }

    private tabErrorState =
        new BehaviorSubject<Record<SideTabKey, boolean>>({
            patientHistory: false,
            reportHistory: false
        });

    tabErrorState$ = this.tabErrorState.asObservable();

    setTabError(key: SideTabKey, hasError: boolean): void {
        this.tabErrorState.next({
            ...this.tabErrorState.value,
            [key]: hasError
        });
    }

}
